const GradientFlagIcon = () => (
  <svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 20.1084H0V0.108398H30L23.7028 10.1084L30 20.1084Z" fill="url(#styledHeroFlagIcon)"/>
    <defs>
      <linearGradient id="styledHeroFlagIcon" x1="32" y1="1.49951" x2="-4.5" y2="23.9995" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ED7598"/>
        <stop offset="0.456219" stopColor="#F75650"/>
        <stop offset="1" stopColor="#FFA661"/>
      </linearGradient>
    </defs>
  </svg>
);

export default GradientFlagIcon;
